import {useLocation, useNavigate} from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import {GuardProps} from 'types';
import {useEffect} from 'react';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({children}: GuardProps) => {
    const {isLoggedIn} = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code'); // '123123'
    useEffect(() => {
        if (!isLoggedIn) {
            if (code)
                navigate(`login?code=${code}`, {replace: true});
            else
                navigate('login', {replace: true});
        }
    }, [isLoggedIn, navigate]);

    return children;
};

export default AuthGuard;
